import { createContext, useContext, useMemo } from "react";

interface TableColumnWidthsContextProps {
  columnWidths: string[];
  setColumnWidths: React.Dispatch<React.SetStateAction<string[]>>;
}

export const TableColumnWidthsContext = createContext<
  TableColumnWidthsContextProps | undefined
>(undefined);

export const useTableColumnWidths = () => {
  const context = useContext(TableColumnWidthsContext);

  if (!context) {
    throw new Error(
      "useTableColumnWidths must be used within TableColumnWidthsContext"
    );
  }

  return context;
};

export const useSingleColumnWidth = (index: number | undefined) => {
  const { columnWidths } = useContext(TableColumnWidthsContext) ?? {};

  if (!columnWidths) {
    throw new Error(
      "useColumnWidth must be used within TableColumnWidthsContext"
    );
  }

  return useMemo(() => {
    if (typeof index !== "number") {
      return 0;
    }
    return parseInt(columnWidths[index], 10) || 0;
  }, [columnWidths, index]);
};
